import { crossfadeAnimation } from '@scisys-uim/uim-common';
import { Component } from '@angular/core';
import { BaseTextSectionComponent } from './base-text-section.component';

const classesEdit: string = 'simple-text-section-editable';
const classesView: string = 'simple-text-section-readonly';
const classesWithControls = 'simple-text-section-with-controls';
const classesWithoutControls = 'simple-text-section-without-controls';
const classesViewWithControls: string = classesView + ' ' + classesWithControls;
const classesViewWithoutControls: string = classesView + ' ' + classesWithoutControls;


@Component({
  selector: 'app-simple-text-section',
  templateUrl: './simple-text-section.component.html',
  styleUrls: ['./simple-text-section.component.scss'],
  animations: [crossfadeAnimation('crossfade')]
})
export class SimpleTextSectionComponent extends BaseTextSectionComponent {
  classesEdit: string = classesEdit;
  classesViewWithControls: string = classesViewWithControls;
  classesViewWithoutControls: string = classesViewWithoutControls;

  constructor() {
    super();
  }
}
